import TitleTooltip from "../../../components/helpers/TitleTooltip";
import {OverlayTrigger, Tooltip} from "react-bootstrap";
export default function Estados({estados}) {
    //const arrayEstados = estados.substring(1, estados.length - 1).split(',');

    return (
        <>
            <div className="symbol-group symbol-hover">
                {
                    estados && estados.map((estado, index) => {
                        return (index < 3 &&
                            <TitleTooltip key={estado} title={estado} placement={'top'}>
                                <div className="symbol symbol-35px symbol-circle">
                                    <span className={estado + " symbol-label fw-bold fs-8"}>{estado}</span>
                                </div>
                            </TitleTooltip>
                        )
                    })
                }
                {
                    estados && estados.length > 3 &&
                    <OverlayTrigger overlay={
                        <Tooltip>
                            <div className={"symbol-group symbol-hover"}>
                                {
                                    estados && estados.map((e) => {
                                        return (
                                            <div key={e} className={"symbol symbol-35px symbol-circle"}>
                                                <span className={e + " symbol-label fw-bold fs-8"}>{e}</span>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </Tooltip>
                    } placement={'bottom'} delay={{show: 250, hide: 400}}>
                        <div className={"symbol symbol-35px symbol-circle"}>
                            <span
                                className={"symbol-label fw-bold fs-8 text-white bg-dark"}>+{estados.length - 3}</span>
                        </div>
                    </OverlayTrigger>
                }
            </div>
        </>
    );
}
